export const CLAIM_LIST: string = 'claims';
